import SearchBarEmployee from './search-employee'

export {
    SearchBarEmployee,
}



// WEBPACK FOOTER //
// ./src/components/consent-management/search-bar/index.js